// FS-2026-065: optional tags start only after an explicit or restored choice.
const deniedGoogleConsent = {
  analytics_storage: "denied",
  ad_storage: "denied",
  ad_user_data: "denied",
  ad_personalization: "denied",
};
let googleStarted = false;
let googlePage: string | null = null;
let metaStarted = false;
let metaPage: string | null = null;

function removeCookies(pattern: RegExp) {
  const domains = window.location.hostname.split(".");
  const names = document.cookie
    .split(";")
    .map((entry) => entry.trim().split("=")[0]);
  for (const name of names.filter((entry) => pattern.test(entry))) {
    document.cookie = `${name}=; Max-Age=0; Path=/; SameSite=Lax`;
    for (let index = 0; index < domains.length - 1; index += 1) {
      const domain = domains.slice(index).join(".");
      document.cookie = `${name}=; Max-Age=0; Path=/; Domain=${domain}; SameSite=Lax`;
      document.cookie = `${name}=; Max-Age=0; Path=/; Domain=.${domain}; SameSite=Lax`;
    }
  }
}

function script(id: string, src: string) {
  if (document.getElementById(id)) return;
  const element = document.createElement("script");
  element.id = id;
  element.async = true;
  element.src = src;
  document.head.appendChild(element);
}

export function syncGoogle(
  allowed: boolean,
  measurementId: string | undefined,
  pathname: string,
) {
  if (!measurementId || !/^G-[A-Z0-9]+$/i.test(measurementId)) return;
  const runtime = window as any;
  runtime[`ga-disable-${measurementId}`] = !allowed;
  if (!allowed) {
    if (googleStarted && googlePage !== null)
      runtime.gtag?.("consent", "update", deniedGoogleConsent);
    googlePage = null;
    removeCookies(/^(_ga($|_)|_gid$|_gat($|_))/);
    return;
  }
  if (!googleStarted) {
    runtime.dataLayer = runtime.dataLayer || [];
    runtime.gtag = function () {
      runtime.dataLayer.push(arguments);
    };
    runtime.gtag("consent", "default", deniedGoogleConsent);
    runtime.gtag("js", new Date());
    runtime.gtag("config", measurementId, { send_page_view: false });
    googleStarted = true;
    script(
      "ga4-tag",
      `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
        measurementId,
      )}`,
    );
  }
  if (googlePage === pathname) return;
  runtime.gtag("consent", "update", {
    ...deniedGoogleConsent,
    analytics_storage: "granted",
  });
  // URLs can contain account, invitation or payment tokens. Never send query/hash.
  runtime.gtag("event", "page_view", {
    page_location: window.location.origin + pathname,
    page_path: pathname,
    page_referrer: document.referrer ? new URL(document.referrer).origin : "",
  });
  googlePage = pathname;
}

export function syncMeta(
  allowed: boolean,
  pixelId: string | undefined,
  pathname: string,
) {
  const runtime = window as any;
  if (!allowed) {
    if (metaStarted && metaPage !== null) runtime.fbq?.("consent", "revoke");
    metaPage = null;
    removeCookies(/^_fb[pc]$/);
    return;
  }
  if (!pixelId || !/^\d+$/.test(pixelId)) return;
  if (!metaStarted) {
    const fbq: any = (...args: unknown[]) => {
      if (fbq.callMethod) fbq.callMethod(...args);
      else fbq.queue.push(args);
    };
    fbq.queue = [];
    fbq.push = fbq;
    fbq.loaded = true;
    fbq.version = "2.0";
    runtime.fbq = fbq;
    runtime._fbq = fbq;
    runtime.fbq("init", pixelId);
    metaStarted = true;
    script("fb-pixel", "https://connect.facebook.net/en_US/fbevents.js");
  }
  if (metaPage === pathname) return;
  runtime.fbq("consent", "grant");
  runtime.fbq("track", "PageView");
  metaPage = pathname;
}

export function syncBarionMarketing(allowed: boolean) {
  (window as any).bp?.("consent", allowed ? "grantConsent" : "rejectConsent");
}
